import * as t from 'io-ts';

export const checklist = t.type({
  question1: t.type({}),
  question2: t.type({}),
  question3: t.type({}),
  question4: t.type({}),
  question5: t.type({}),
  question6: t.type({}),
  question7: t.type({}),
  question8: t.type({}),
  question9: t.type({}),
  question10: t.type({}),
  question11: t.type({}),
});

export type Checklist = t.TypeOf<typeof checklist>;

export const patchChecklist = t.partial(checklist.props);

export type PatchChecklist = t.TypeOf<typeof patchChecklist>;
